import type { AxiosResponse } from "axios";
import { function as function_, taskEither } from "fp-ts";
import type { z } from "zod";

import { UnexpectedError } from "~/shared/error";

function process<T = unknown, D = unknown, Schema extends z.ZodSchema<unknown> = z.ZodSchema>(
  fetcher: () => Promise<AxiosResponse<T, D>>,
  responseSchema: Schema,
) {
  return function_.pipe(
    taskEither.tryCatch(fetcher, (reason) => new UnexpectedError(reason)),
    taskEither.flatMap((response) => {
      const { status, data: body } = response;
      const { success, data, error } = responseSchema.safeParse({ status, body });
      return success
        ? taskEither.right(data as z.infer<Schema>)
        : taskEither.left(new UnexpectedError(error));
    }),
  );
}

export { process };
